import { useBuilding } from "@/api/functions/building";
import AccessRolesTable from "@/components/building_admin/access_roles/AccessRolesTable";
import StarwatchAccessRolesTable from "@/components/building_admin/starwatch_access_roles/StarwatchAccessRolesTable";
import { AcsConnectivityBanner } from "@/components/AcsConnectivityBanner";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAccessAdminPermission } from "@/hooks/useAccessAdminPermission";
import { isStarwatchIntegrationEnabled } from "@/lib/starwatch";

export const Route = createFileRoute(
  "/_portal/building/access-role-management",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { data: building } = useBuilding();
  const navigate = useNavigate();
  const { isBuildingAccessAdmin } = useAccessAdminPermission({
    withoutRedirect: false,
  });

  // allowAccessRoleManagement turns the page on for any building. Starwatch
  // buildings keep the Sharry roles until starwatchIntegrationEnabled is on.
  const canManageRoles = !!building?.allowAccessRoleManagement;
  const isStarwatch = isStarwatchIntegrationEnabled(building);

  useEffect(() => {
    if (!canManageRoles) {
      navigate({ to: "/401", replace: true });
    }
  }, [canManageRoles, navigate]);

  if (!isBuildingAccessAdmin) {
    return null;
  }

  return (
    <>
      {canManageRoles && (
        <>
          <AcsConnectivityBanner />
          <div className="pageHeader">
            <h1>{t("SIDEBAR.BUILDING_ACCESS_ROLE_MANAGEMENT")}</h1>
            <p>{t("PAGES.BUILDING_ACCESS_ROLE_MANAGEMENT.SUBHEADER")}</p>
          </div>
          {isStarwatch ? <StarwatchAccessRolesTable /> : <AccessRolesTable />}
        </>
      )}
    </>
  );
}
